<template>
  <Wrap>
    <UiBreadcrumbs
      :list="crumbs"
      :events-identifier="eventsIdentifier"
      :track-event="breadcrumbsTrackEvent"
    />
  </Wrap>
</template>

<script lang="ts" setup>
  import { UiBreadcrumbs, type TrackEvent } from '@experience/core-breadcrumbs-ui';

  import { trackEvent } from '@/services/analytics';
  import Wrap from '@/shared/ui/Wrap.vue';

  const breadcrumbsTrackEvent = trackEvent as TrackEvent;
  const eventsIdentifier = 'author-page';

  const crumbs = [
    {
      label: 'Главная',
      to: '/',
    },
    {
      label: 'Журнал',
      to: '/journal/',
    },
  ];
</script>
